// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 1H4V23H14.7964C12.5643 22.0463 11 19.8308 11 17.25C11 17.1663 11.0016 17.0829 11.0049 17H6V3H18V11.0445C18.7101 11.1295 19.3836 11.3334 20 11.6359V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 17.25C22 18.1992 21.7216 19.0834 21.2419 19.8254L22.9142 21.5017L21.4983 22.9142L19.8282 21.2401C19.0857 21.7209 18.2004 22 17.25 22C14.6266 22 12.5 19.8734 12.5 17.25C12.5 14.6266 14.6266 12.5 17.25 12.5C19.8734 12.5 22 14.6266 22 17.25ZM20 17.25C20 15.7312 18.7688 14.5 17.25 14.5C15.7312 14.5 14.5 15.7312 14.5 17.25C14.5 18.7688 15.7312 20 17.25 20C18.0059 20 18.6906 19.695 19.1876 19.2014L19.1967 19.1924C19.6931 18.6949 20 18.0083 20 17.25Z"}}]};

const PhoneSearchFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'phone-search-filled',
    ref,
    icon: element,
  },
));

PhoneSearchFilledIcon.displayName = 'PhoneSearchFilledIcon';

export default PhoneSearchFilledIcon;
